import React from 'react';
import { useMaskData } from '../hooks';

export const Mask: React.FC<{ type: string }> = React.memo(({ type }) => {
    const maskData = useMaskData();
    if (!maskData.isShow) return null;
    return <div className={`p-editor__mask p-editor__mask-${type}`} style={{ background: maskData.background }}></div>;
});
